import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/home/HomeView.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/about/AboutView.vue"),
  },
  {
    path: "/contact-us",
    name: "Contact Us",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/contact/ContactView.vue"),
  },
  {
    path: "/categories",
    name: "Categories",
    component: () =>
      import(
        /* webpackChunkName: "home" */ "../views/categories/CategoriesView.vue"
      ),
  },
  {
    path: "/categories/:id",
    name: "Show Category",
    component: () =>
      import(
        /* webpackChunkName: "home" */ "../views/categories/ShowCategory.vue"
      ),
  },
  {
    path: "/categories/:id/company",
    name: "Company View",
    component: () =>
      import(
        /* webpackChunkName: "company" */ "../views/categories/CompaniesView.vue"
      ),
  },
  {
    path: "/categories/:id/company/:category_details/:guarantee_amount",
    name: "Category Details",
    component: () =>
      import(
        /* webpackChunkName: "home" */ "../views/categories/CategoryDetails.vue"
      ),
  },
  {
    path: "/categories/:id/company/:category_details/:guarantee_amount/order-now",
    name: "Order View",
    component: () =>
      import(
        /* webpackChunkName: "home" */ "../views/categories/OrderView.vue"
      ),
  },
  {
    path: "/categories/:id/company/:category_details/:guarantee_amount/order-now/:order_id/payment",
    name: "Payment View",
    component: () =>
      import(
        /* webpackChunkName: "home" */ "../views/categories/PaymentView.vue"
      ),
  },
  // Start Sale
  {
    path: "/categories/:id/:company_id/company-products",
    name: "Company Details",
    component: () =>
      import(
        /* webpackChunkName: "company details" */ "../views/categories/CompanyDetails.vue"
      ),
  },
  {
    path: "/categories/:id/:company_id/company-products/choosed-products",
    name: "Choosed Products",
    component: () =>
      import(
        /* webpackChunkName: "company details" */ "../views/categories/ChoosedProducts.vue"
      ),
  },
  {
    path: "/categories/:id/:company_id/company-products/choosed-products/sales",
    name: "Sales View",
    component: () =>
      import(
        /* webpackChunkName: "company details" */ "../views/categories/SalesView.vue"
      ),
  },
  {
    path: "/categories/:id/:company_id/company-products/choosed-products/sales/:payment_id/payment-process",
    name: "Process Payment",
    component: () =>
      import(
        /* webpackChunkName: "company details" */ "../views/categories/ProcessPayment.vue"
      ),
  },

  {
    path: "/profile",
    name: "Profile View",
    component: () =>
      import(
        /* webpackChunkName: "profile" */ "../views/profile/ProfileView.vue"
      ),
  },
  {
    path: "/favorites",
    name: "Favorite View",
    component: () =>
      import(
        /* webpackChunkName: "profile" */ "../views/favorite/FavoriteView.vue"
      ),
  },
  {
    path: "/rate-product/:model_id/:type",
    name: "Rate Product",
    component: () =>
      import(
        /* webpackChunkName: "profile" */ "../views/favorite/RateProduct.vue"
      ),
  },
  {
    path: "/requests",
    name: "Requests View",
    component: () =>
      import(
        /* webpackChunkName: "profile" */ "../views/requests/RequestsView.vue"
      ),
  },
  {
    path: "/requests/:id",
    name: "Request Details",
    component: () =>
      import(
        /* webpackChunkName: "profile" */ "../views/requests/RequestDetails.vue"
      ),
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../components/Registration/LoginView.vue"
      ),
    meta: {
      hideNavbar: true,
    },
  },
  {
    path: "/sign-up",
    name: "Sign up",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../components/Registration/SignupView.vue"
      ),
    meta: {
      hideNavbar: true,
    },
  },
  {
    path: "/forget-password",
    name: "Forget Password",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../components/Registration/ForgetPasswordView.vue"
      ),
    meta: {
      hideNavbar: true,
    },
  },
  {
    path: "/check-code",
    name: "Check Code",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../components/Registration/CheckCodeView.vue"
      ),
    meta: {
      hideNavbar: true,
    },
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../components/Registration/ResetPasswordView.vue"
      ),
    meta: {
      hideNavbar: true,
    },
  },
  {
    path: "/verified-account",
    name: "Verified Account",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../components/Registration/VerifiedAccount.vue"
      ),
    meta: {
      hideNavbar: true,
    },
  },
  {
    path: "/verified-code",
    name: "Verified Code",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../components/Registration/VerifiedCode.vue"
      ),
    meta: {
      hideNavbar: true,
    },
  },

  {
    path: "/internal-server",
    name: "InternalServer",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../views/general-pages/InternalServer.vue"
      ),
  },
  {
    path: "/not-authenticated",
    name: "NotAuthenticated",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../views/general-pages/NotAuthenticated.vue"
      ),
  },
  {
    path: "/privacy",
    name: "PrivacyView",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../views/general-pages/PrivacyView.vue"
      ),
  },
  {
    path: "/terms",
    name: "TermsView",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../views/general-pages/TermsView.vue"
      ),
  },
  {
    path: "/page-not-found",
    alias: "*",
    name: "NotFound",
    component: () =>
      import(
        /* webpackChunkName: "TermsOfService" */ "../views/general-pages/NotFound.vue"
      ),
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior() {
    window.scrollTo(0, 0);
  },
});

export default router;
